<template>
  <div class="planilha">
    <div style="position: fixed; top: 10px; z-index: 9000; right: 30px">
      <Filtro @exportar="exportar">
        <template slot="body">
          <div class="select-div">
            <label for="">Microrregião</label>
            <select v-model="filtro.microrregiao">
              <option :value="null">Todas</option>
              <option v-for="(c, i) in microrregioes" :key="i" :value="i">
                {{ c }}
              </option>
            </select>
          </div>
          <div class="select-div">
            <label for="">Mesorregião</label>
            <select v-model="filtro.mesorregiao">
              <option :value="null">Todas</option>
              <option v-for="(c, i) in mesorregioes" :key="i" :value="i">
                {{ c }}
              </option>
            </select>
          </div>
          <div class="select-multiple-div">
            <label for="">Cidade</label>
            <select v-model="filtro.cidade" multiple>
              <option :value="null">Todas</option>
              <option v-for="(c, i) in cidades" :key="i" :value="c.id">
                {{ c.nome }}
              </option>
            </select>
          </div>
        </template>
      </Filtro>
    </div>

    <div class="table-responsive">
      <table class="table table-modern">
        <thead>
        <tr>
          <th style="text-align: center; text-transform: none; letter-spacing: normal; color: #94a3b8 !important;" colspan="6">
            Clique nos cabeçalhos para ordenar
          </th>
        </tr>
        <tr>
          <th>Nº</th>
          <th @click="ordem('nome_cidade')">Cidade</th>
          <th style="text-align: right" @click="ordem('potencia_instalada')">
            Potência Instalada (kW)
          </th>
          <th style="text-align: right" @click="ordem('populacao')">
            População
          </th>
          <th
            style="text-align: right"
            @click="ordem('geracao_distribuida_per_capita')"
          >
            Potência por habitante (kW)
          </th>
          <th style="text-align: right" @click="ordem('competitividade')">
            Competitividade
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(d, i) in difusaoFiltrada" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ d.nome_cidade }}</td>
          <td style="text-align: right">
            {{ numberWithCommas(d.potencia_instalada) }}
          </td>
          <td style="text-align: right">{{ numberWithCommas(d.populacao) }}</td>
          <td style="text-align: right">
            {{ numberWithCommas(d.geracao_distribuida_per_capita) }}
          </td>
          <td style="text-align: right">
            {{ (d.competitividade * 100).toFixed(2).replace(".", ",") }}%
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import Filtro from "../Filtro.vue";
export default {
  props: ["difusaoinit"],
  components: {
    Filtro,
  },
  data() {
    return {
      difusao: this.difusaoinit,
      ordenar: {
        coluna: null,
        crescente: true,
      },
      filtro: {
        cidade: [],
        mesorregiao: null,
        microrregiao: null
      },
    };
  },
  computed: {
    cidades() {
      var c = [];
      for (const d of this.difusao) {
        c.push({ id: d.cidade_id, nome: d.nome_cidade });
      }
      return c;
    },
    microrregioes() {
      var c = {};
      for (const d of this.difusao) {
        c[d.codigo_microrregiao] = d.nome_microrregiao;
      }
      return c;
    },
    mesorregioes() {
      var c = {};
      for (const d of this.difusao) {
        c[d.codigo_mesorregiao] = d.nome_mesorregiao;
      }
      return c;
    },
    difusaoFiltrada() {
      var des = [];
      for (const d of this.difusao) {
        var micro  = this.filtro.microrregiao == null || d.codigo_microrregiao == this.filtro.microrregiao;
        var meso   = this.filtro.mesorregiao == null || d.codigo_mesorregiao == this.filtro.mesorregiao;
        var cidade = true;
        
        if ( this.filtro.cidade.length > 0 ) {
          cidade = false;
          for ( const c of this.filtro.cidade ) {
            if ( c == null || d.cidade_id == c ) {
              cidade = true;
            }
          }
        }

        if (micro && meso && cidade) {
          des.push(d);
        }
      }
      return des;
    },
  },
  methods: {
    exportar() {
      var json = [];
      json.push({
        1: "Cidade",
        2: "Potência Instalada (kW)",
        3: "População",
        4: "Potência por habitante (kW)",
        5: "Competitividade",
      });
      for (const d of this.difusaoFiltrada) {
        json.push({
          1: d.nome_cidade,
          2: parseFloat(d.potencia_instalada).toFixed(2).replace(".", ","),
          3: d.populacao,
          4: parseFloat(d.geracao_distribuida_per_capita).toFixed(2).replace(".", ","),
          5: (d.competitividade * 100).toFixed(2).replace(".", ","),
        });
      }
      PLANILHA.export("Solarmap", "xlsx", json);
    },
    ordem(col) {
      this.ordenar.coluna = col;
      this.ordenar.crescente = !this.ordenar.crescente;
      if (this.ordenar.coluna) {
        this.difusao.sort((a, b) => {
          var va = a[this.ordenar.coluna];
          var vb = b[this.ordenar.coluna];

          if (isNaN(va) || isNaN(vb)) {
            if (va == vb) {
              return 0;
            }
            if (this.ordenar.crescente) {
              if (va > vb) {
                return 1;
              } else {
                return -1;
              }
            } else {
              if (va > vb) {
                return -1;
              } else {
                return 1;
              }
            }
          } else {
            if (this.ordenar.crescente) {
              return va - vb;
            } else {
              return vb - va;
            }
          }
        });
      }
      this.$forceUpdate();
    },
    numberWithCommas(x) {
      var parts = x.toString().replace(".", ",");

      parts = parts.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return parts;
    },
  },
  created() {},
};
</script>

<style>
th {
  cursor: pointer;
}
.select-div {
  height: 100px;
}
.select-div select {
  background-color: #999999;
  color: white;
  padding: 12px;
  width: 100%;
  border: none;
  font-size: 20px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
  -webkit-appearance: button;
  appearance: button;
  outline: none;
}

.select-div label {
  font-size: 16px;
}

.select-div:hover::before {
  color: rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.2);
}

.select-div select option {
  padding: 30px;
  background-color: #fff;
  color: #333333;
}

.select-multiple-div {
  height: calc(100% - 200px);
}

.select-multiple-div select {
  background-color: #999999;
  padding: 12px;
  width: 100%;
  height: calc(100% - 30px);
  border: none;
  font-size: 20px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
}

.select-multiple-div label {
  font-size: 16px;
}

.select-multiple-div:hover::before {
  color: rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.2);
}

.select-multiple-div select option {
  padding: 5px 10px;
  color: #fff;
}
</style>